import axios from 'axios'
import { toast } from 'react-toastify'

const api = async (method, url, data, showErrorMessage) => {
  try {
    return axios(`${process.env.REACT_APP_API_BASE_URL}${url}`, {
      method: method,
      data: data,
      headers: {
        authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then((result) => {
        return result.data.data ? result.data.data : result.data.message
      })
      .catch((err) => {
        // console.log(err)
        if (showErrorMessage) {
          toast.error(err.response.data.message)
        }
        if (err.response.code === 401) {
          toast.error(err.response.data.message)
          localStorage.clear()
          window.reload()
        }
        return null
      })
  } catch (error) {
    return null
  }
}

export default api
